// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import { LoadingOverlayStyle } from "@insite/mobius/LoadingOverlay";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { productAvailabilityModalStyles } from "@pace/App/Components/Product/ProductAvailabilityModal";
import { fontConfig } from "@pace/XDL/PreStyle/typography";
import { color, sharedContainerStyles, styledScrollbar, xScreen } from "@pace/XDL/Utilities";
import { css } from "styled-components";

productAvailabilityModalStyles.availabilityByWarehouseModal = {
    mergeCss: true,
    cssOverrides: {
        modalContainer: css`
            max-height: 80vh;
        `,
        modalContent: css`
            ${LoadingOverlayStyle} {
                display: flex;
                flex-direction: column;
                gap: 12px;
                min-height: 100px;
            }
        `,
    },
};

productAvailabilityModalStyles.currentWarehouseInfoContainer = {
    css: css`
        display: flex;
        flex: 1;
        gap: 8px;

        ${xScreen("lt", "md")} {
            flex-direction: column;
            gap: 0;
        }
    `,
};

productAvailabilityModalStyles.inventoryInfoContainer = {
    gap: 12,
};

const _typographyStyle: any = {
    variant: "p",
    css: css`
        margin: 0;
    `,
};

productAvailabilityModalStyles.currentWarehouseLabel = {
    ..._typographyStyle,
    weight: fontConfig.weight.bold,
};

productAvailabilityModalStyles.currentWarehouseValue = {
    ..._typographyStyle,
};

productAvailabilityModalStyles.statusSelectionContainer = {
    width: [12, 6, 6, 6, 6],
};

productAvailabilityModalStyles.warehouseStateSelection = {
    cssOverrides: {
        formField: css`
            ${TypographyStyle} {
                font-weight: ${fontConfig.weight.regular};
            }
        `,
        formInputWrapper: css`
            &&&& {
                margin-top: 0;
                width: auto;
                select {
                    width: 215px;
                }
            }
        `,
    },
};

productAvailabilityModalStyles.networkQtyContainer = {
    width: [12, 6, 6, 6, 6],
    css: css`
        gap: 4px;
        justify-content: end;
        align-items: center;
        ${IconWrapper} {
            opacity: 0.6;
        }

        ${xScreen("lt", "md")} {
            justify-content: start;
        }
    `,
};

productAvailabilityModalStyles.networkQtyLabel = {
    size: 12,
    lineHeight: "13px",
    weight: fontConfig.weight.bold,
};
productAvailabilityModalStyles.networkQtyValue = {
    size: 12,
    lineHeight: "17px",
    color: "common.ui5",
};

productAvailabilityModalStyles.networkQtyContainer;

productAvailabilityModalStyles.centeringWrapper = {
    ...sharedContainerStyles.centeringContent,
};

productAvailabilityModalStyles.actionButton = {
    variant: "tertiary",
    typographyProps: {
        variant: "headerSecondary",
        transform: "unset",
        forwardAs: "p",
        color: "text.link",
        css: css`
            &:hover {
                color: ${color("common.ui8")};
            }
        `,
    },
    css: css`
        padding: 0;
        min-height: auto;
    `,
};

productAvailabilityModalStyles.tableContainer = {
    css: css`
        height: 280px;
        overflow: auto;
        width: 100%;
        ${styledScrollbar()}
    `,
};

productAvailabilityModalStyles.availabilityByWarehouseNameCell = {
    css: css`
        max-width: 300px;
        white-space: pre-wrap;
    `,
};
